import Typegraphy from "@insite/mobius/Typography";
import React from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";

const enum fields  {
    popupTitle = "popupTitle",
    popupContent = "popupContent"
}

interface Props extends WidgetProps{
    fields: {
        [fields.popupTitle]: String;
        [fields.popupContent]: String;
    }
}


const PopupWidget: React.FC<Props> = props => {
    return (
        <div>
            <Typegraphy> {props.fields.popupTitle}</Typegraphy>
            <Typegraphy> {props.fields.popupContent}</Typegraphy>
        </div>
        
    )
 }

 const definition: WidgetDefinition = {
    group: "Testing",
    fieldDefinitions: [
        {
            name: fields.popupTitle,
            displayName: "Popup Title",
            editorTemplate: "TextField",
            fieldType: "General",
            tooltip: "title tip",
            defaultValue: '',
            placeholder: "text placeholder",
            isRequired: true,
        },
        {
            name: fields.popupContent,
            displayName: "Popup content",
            editorTemplate: "TextField",
            fieldType: "General",
            tooltip: "title tip",
            defaultValue: '',
            placeholder: "text placeholder",
            isRequired: true,
        },
    ]
}

//The widgetmodule define:
// -The component used the render the widget
// -How the widget should apper in the CMS
// -How the widget is editable in the cms
// -many other things 
const widgetModule: WidgetModule = {
    component: PopupWidget,
    definition
}


export default widgetModule;